import {httpRequest} from '../config/axios';
import {ConfigConstant} from '../constants/config';
const getCommonFilterValues = async ({
  fetchAll = false,
  addDefaultFilter = 'ALL',
  country = '',
  cityList = [],
  storeList = [],
}) => {
  try {
    const commonFilterApis = [
      {
        url: '/get-channel-list',
        method: 'GET',
        fetch: fetchAll,
        body: {},
        name: 'channel',
      },
      {
        url: '/get-city-list',
        method: 'POST',
        fetch: fetchAll || country,
        body: {partnerCode: ConfigConstant.CODE_REBELPLUS, ...(country && {countryCode: country})},
        name: 'city',
      },
      {
        url: '/get-store-list',
        method: 'POST',
        fetch: fetchAll || storeList.length,
        body: {
          partnerCode: ConfigConstant.CODE_REBELPLUS,
          ...(storeList?.length && {partnerPhyStoreCode: storeList.filter((val) => val !== 'ALL')}),
        },
        name: 'store',
      },
      {
        url: '/get-phystore-list',
        method: 'POST',
        fetch: fetchAll || cityList.length,
        body: {
          partnerCode: ConfigConstant.CODE_REBELPLUS,
          ...(cityList.length && {city: cityList.filter((val) => val !== 'ALL')}),
        },
        name: 'phyStore',
      },
      {
        url: '/get-brand-list',
        method: 'POST',
        fetch: fetchAll || country,
        body: {partnerCode: ConfigConstant.CODE_REBELPLUS, ...(country && {countryCode: country})},
        name: 'brand',
      },
    ];
    const commonFilterValues = {};
    const countryCodeMap = {};
    const filteredCommonFilterApis = commonFilterApis.filter(({fetch}) => fetch);
    const promises = filteredCommonFilterApis.map(async ({url, method, body, name}) => {
      const data = await httpRequest({method, url, data: body});
      return {name, data};
    });
    const results = await Promise.allSettled(promises);
    results.forEach((result) => {
      if (result.status === 'fulfilled') {
        const {name, data} = result.value;
        const options = data?.data?.data?.data?.list;
        switch (name) {
          case 'channel':
            commonFilterValues.channelCode = [];
            options?.forEach((option) => {
              if (option.isGroupChannel) {
                const groupChannelCodes = ConfigConstant.MONGO_CONFIG?.CHANNEL_GROUPS?.[option.code];
                if (Array.isArray(groupChannelCodes) && groupChannelCodes.length > 0) {
                  groupChannelCodes.forEach((groupChannelCode) => {
                    const groupChannel = options.find((o) => o.code === groupChannelCode);
                    if (groupChannel?.code && groupChannel?.value) {
                      commonFilterValues.channelCode.push({
                        label: `${option.value}-${groupChannel.value}`,
                        code: `${option.code}-${groupChannel.code}`,
                      });
                    }
                  });
                }
              } else {
                commonFilterValues.channelCode.push({
                  label: `${option.value}-direct`,
                  code: `${option.code}-${option.code}`,
                });
              }
            });
            break;
          case 'brand': {
            commonFilterValues.partnerBrandCode = [];
            const defaultBrandFilter =
              addDefaultFilter === 'NA' ? {label: 'NA', code: 'NA'} : {label: 'ALL', code: 'ALL'};
            options?.forEach((option) => {
              if (option.code && option.value) {
                commonFilterValues.partnerBrandCode.push({
                  label: `${option.value} (${option.code})`,
                  code: option.code,
                });
              }
            });
            commonFilterValues.partnerBrandCode?.sort((a, b) => (a.label > b.label ? 1 : -1));
            commonFilterValues.partnerBrandCode.unshift(defaultBrandFilter);
            break;
          }
          case 'city': {
            commonFilterValues.city = [];
            const defaultCityFilter =
              addDefaultFilter === 'NA' ? {label: 'NA', code: 'NA'} : {label: 'ALL', code: 'ALL'};
            options?.forEach((option) => {
              if (option.city) {
                commonFilterValues.city.push({label: option.city, code: option.city});
              }
            });
            options?.forEach((option) => {
              if (option.code && option.value) {
                countryCodeMap[option.code] = {label: option.value, code: option.code};
              }
            });
            commonFilterValues.countryCode = Object.values(countryCodeMap);
            commonFilterValues.city?.sort((a, b) => (a.label > b.label ? 1 : -1));
            commonFilterValues.city.unshift(defaultCityFilter);
            break;
          }
          case 'store':
            commonFilterValues.partnerStoreCode =
              addDefaultFilter === 'NA' ? [{label: 'NA', code: 'NA'}] : [{label: 'ALL', code: 'ALL'}];
            options?.forEach((option) => {
              if (option.code) {
                commonFilterValues.partnerStoreCode.push({label: option.code, code: option.code});
              }
            });
            break;
          case 'phyStore': {
            commonFilterValues.partnerPhyStoreCode = [];
            const defaultPhyStoreFilter =
              addDefaultFilter === 'NA' ? {label: 'NA', code: 'NA'} : {label: 'ALL', code: 'ALL'};
            options?.forEach((option) => {
              if (option.code && option.value) {
                commonFilterValues.partnerPhyStoreCode.push({
                  label: `${option.value} (${option.code})`,
                  code: option.code,
                });
              }
            });
            commonFilterValues.partnerPhyStoreCode?.sort((a, b) => (a.label > b.label ? 1 : -1));
            commonFilterValues.partnerPhyStoreCode.unshift(defaultPhyStoreFilter);
            break;
          }
          default:
            break;
        }
      }
    });
    if (ConfigConstant.MONGO_CONFIG.OPERATION_TYPES) {
      commonFilterValues.operationType = Object.values(ConfigConstant.MONGO_CONFIG.OPERATION_TYPES);
    }
    if (ConfigConstant.MONGO_CONFIG.TOGGLE_TYPES) {
      commonFilterValues.toggleType = Object.values(ConfigConstant.MONGO_CONFIG.TOGGLE_TYPES);
    }
    if (ConfigConstant.MONGO_CONFIG.STORE_TOGGLE_TYPES) {
      commonFilterValues.storeToggleType = Object.values(ConfigConstant.MONGO_CONFIG.STORE_TOGGLE_TYPES);
    }
    if (ConfigConstant.MONGO_CONFIG.REQUEST_CLIENT) {
      commonFilterValues.requestClient = Object.values(ConfigConstant.MONGO_CONFIG.REQUEST_CLIENT);
    }
    commonFilterValues.date = [
      {
        label: 'Today',
        code: 'Today',
      },
      {
        label: 'Yesterday',
        code: 'Yesterday',
      },
      {
        label: 'This Week',
        code: 'This Week',
      },
      {
        label: 'Last 7 Days',
        code: 'Last 7 Days',
      },
      {
        label: 'This Month',
        code: 'This Month',
      },
      {
        label: 'Last 30 Days',
        code: 'Last 30 Days',
      },
      {
        label: 'Custom Date',
        code: 'Custom Date',
      },
    ];
    commonFilterValues.status = [
      {
        label: 'Success',
        code: 'success',
      },
      {
        label: 'Failed',
        code: 'failed',
      },
      {
        label: 'Queued',
        code: 'queued',
      },
    ];
    commonFilterValues.mappingStatus = [
      {
        label: 'active',
        code: 'active',
      },
      {
        label: 'inactive',
        code: 'inactive',
      },
    ];
    commonFilterValues.groupBy = [
      {
        label: 'Brand',
        code: 'partnerBrandCode-partnerBrandName',
      },
      {
        label: 'Channel',
        code: 'channelCode-channelName:channelGroupCode-channelGroupName',
      },
      {
        label: 'Store',
        code: 'partnerPhyStoreCode-partnerPhyStoreName',
      },
      {
        label: 'Virtual Store Code',
        code: 'partnerStoreCode-partnerStoreCode',
      },
      {
        label: 'City',
        code: 'city-city',
      },
    ];
    commonFilterValues.classification = [
      {
        label: 'Tech',
        code: 'Tech',
      },
      {
        label: 'Ops',
        code: 'Ops',
      },
      {
        label: 'Aggregator',
        code: 'Aggregator',
      },
      {
        label: 'Other',
        code: 'Other',
      },
    ];
    return {
      ...commonFilterValues,
    };
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default getCommonFilterValues;
